import { PageHeader } from "@/shared/ui/PageHeader";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { AnalyticsStatsRow } from "./components/AnalyticsStatsRow";
import { TrafficChart } from "./components/TrafficChart";
import { TrafficSources } from "./components/TrafficSources";
import { TopPages } from "./components/TopPages";
import { DeviceBreakdown } from "./components/DeviceBreakdown";

export function AnalyticsDashboard() {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <PageHeader title={t.analytics.pageTitle} description={t.analytics.pageDescription} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 md:gap-5">
        <AnalyticsStatsRow />
        <TrafficChart />
        <TrafficSources />
        <TopPages />
        <DeviceBreakdown />
      </div>
    </div>
  );
}
